export type SortOrder = 'asc' | 'desc';

/**
 * Array of all SortOrder values.
 */
export const SORTORDER_VALUES: readonly SortOrder[] = ['asc', 'desc'] as const;
